import React, {useRef, useEffect} from "react"
import styled from "styled-components"

import FormattedMessage, {FormattedRelative, injectIntl, InjectIntl} from "@irati/utils/lang"
import {FeedEntityType, GroupCelebration} from "@irati/types"
import tracking from "@irati-tracking/recognition/recognition"
import Flex from "@irati/ui/src/Flex"
import {Label, H2} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {historyContext} from "@irati/utils/history"
import {RECOGNITION} from "@irati-web/app/src/routeConfig"
import {Comments, CreateComment} from "../shared/Comments"
import Comment from "../shared/Comments/Comment"
import ProfilePicGroup, {DEFAULT_MULTIPLE_PICTURE_SIZE, DEFAULT_SINGLE_PICTURE_SIZE} from "../../ProfilePicGroup"

import {CelebrationIcon, ProfilePicContainer} from "../../Polls/ClosedPoll/styled"
import LineThroughText from "../shared/layouts/LineThroughText"
import GroupCelebrationAddReward from "../../Icons/GroupCelebrationAddReward"
import LikeButton from "../../Reactions/LikeButton"
const MAX_CHARACTERS_MESSAGE = 140
const Container = styled(Flex)`
  padding-top: ${({theme}) => theme.spacing.nine};
  flex-direction: column;
`
const Ribbon = styled.img`
  width: 100%;
  position: absolute;
  top: ${({theme}) => theme.spacing.four};
  left: 0;
`

interface Props extends InjectIntl {
  id?: string
  groupCelebration: GroupCelebration
}

const ViewCelebration: React.FC<Props> = (props, {app}) => {
  const textarea = useRef<HTMLTextAreaElement>()
  const {groupCelebration} = props
  const theme = useTheme()
  const greetingLabel = `${groupCelebration?.greeting?.label}, ${groupCelebration?.receiver.firstName} ${groupCelebration?.receiver.lastName}`

  useEffect(() => {
    const source = app === RECOGNITION ? "recognition_feed" : "my_recognition"
    tracking.viewGreetingCardDetails(source)
  }, [])
  return (
    <Container>
      <Ribbon src={groupCelebration.greeting?.image?.href!} />
      <Flex justifyContent="center">
        <ProfilePicContainer>
          <CelebrationIcon src={groupCelebration?.greeting?.icon?.href} />
          <ProfilePicGroup
            users={[groupCelebration?.receiver]}
            outerWrapperSize={DEFAULT_MULTIPLE_PICTURE_SIZE}
            singlePictureSize={DEFAULT_SINGLE_PICTURE_SIZE}
          />
        </ProfilePicContainer>
      </Flex>
      <Label className="center" small>
        <FormattedMessage id="recognition.popup.groupCelebration.headerType" />
      </Label>
      <H2 textAlign="center">
        <FormattedMessage id={greetingLabel} />
      </H2>
      <LineThroughText>
        <FormattedRelative value={groupCelebration.when} />
      </LineThroughText>
      {groupCelebration.messages?.length > 0 && (
        <Flex direction="column" gap={2}>
          {groupCelebration.messages?.map((colleagueMessage) => (
            <Comment key={colleagueMessage.uuid} comment={colleagueMessage} hideActions hideTime maxCharacters={MAX_CHARACTERS_MESSAGE} />
          ))}
        </Flex>
      )}
      <Flex marginTop={3} gap={theme.spacing.oneAndHalf}>
        <LikeButton parent={groupCelebration} type={FeedEntityType.GroupCelebration} />
        <GroupCelebrationAddReward item={groupCelebration} />
      </Flex>
      <Flex direction="column" marginTop={3}>
        <CreateComment item={groupCelebration} key={groupCelebration.comments?.results.length} inputRef={(t) => (textarea.current = t)} />
        <Comments item={groupCelebration} />
      </Flex>
    </Container>
  )
}
ViewCelebration.contextTypes = historyContext
export default injectIntl(ViewCelebration)
